import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { ReactComponent as Cancel } from '../assets/cancel.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';
import { CheckboxPhone } from "./UI";
import db from "../firebase";
import { doc, getDocs, collection, query, where, orderBy } from "firebase/firestore";

export default function Airdrop({saveAirdrop, hideAirdrop, project}) {
	const [users, setUsers] = useState([]);
	const [filteredUsers, setFilteredUsers] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');
	const [image, setImage] = useState();
	const [airdropImage, setAirdropImage] = useState();
	const [fileError, setFileError] = useState('');
	const [usersError, setUsersError] = useState('');
	const [message, setMessage] = useState('');
	const {
		register,
		reset,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const imageMimeType = /image\/(png|gif|jpg|jpeg|webp|svg\+xml)/i;

	useEffect(() => {
		getUsers();
	}, [project.id]);

	useEffect(() => {
		const filtered = users.filter(user => 
			user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
			(user.phone && user.phone.includes(searchTerm))
		);
		setFilteredUsers(filtered);
	}, [searchTerm, users]);

	const getUsers = async () => {
		const usersRef = collection(db, "users");
		const q = query(
			usersRef, 
			where("project_id", "==", project.id),
			orderBy("__name__", "desc") // Use document ID as a proxy for creation time
		);
		const snapshot = await getDocs(q);
		const projectUsers = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
		setUsers(projectUsers);
		setFilteredUsers(projectUsers);
	}

	const remove = event => {
		setSelectedFile(false);
		setImage(false);
	}

	const clearFile = event => {
		event.target.value = '';
	}

	const changeFile = event => {
		setFileError('');

		if (!event.target.files || event.target.files.length === 0) {
			setSelectedFile(false);
			return;
		}
		var file = event.target.files[0];

		setSelectedFile(file);

		if (file === 'undefined') {
			setFileError("Not valid image");
			return;
		}

		if (!imageMimeType.test(file.type)) {
			setFileError("Image type is not valid");
			return;
		}

		setAirdropImage(file);
	};

	const [selectedFile, setSelectedFile] = useState();
	useEffect(() => {
		if (!selectedFile) {
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFile);
		if (objectUrl) {
			setImage(objectUrl);
		}

		return () => URL.revokeObjectURL(objectUrl);
	}, [selectedFile]);

	const save = async (data) => {
		let selectedUsers = Object.entries(data['users'])
			.filter(([_, isSelected]) => isSelected)
			.map(([userId, _]) => userId);

		if (selectedUsers.length === 0) {
			setUsersError('Select at least one user');
			return;
		}

		data['image'] = airdropImage;
		data['users'] = selectedUsers;

		saveAirdrop(data);
		hideAirdrop();
	}

	return (
		<div className="wrapper">
			<div className="modal">
				<div className="header">
					<h2>Send airdrop to project users</h2>
					<div className="cancel" onClick={hideAirdrop}>
						<Cancel/>
						Close
					</div>
				</div>

				<form onSubmit={handleSubmit(save)}>
					<div className="flex_top">
						<div>
							<label className="label">Name</label>
							<input type="text" {...register("name", { required: "Name is required" })} />
							<div className="error">{errors["name"] ? errors["name"].message : '' }</div>
							<div className="subheader">
								<div className="flex_center">
									<label className="file-label">
										<input
											type="file"
											{...register("image", {required: "Image is required"})}
											placeholder={"Url"}
											onChange={changeFile}
											onClick={clearFile}
										/>
										<div className="error">{errors["image"] ? errors["image"].message : '' }</div>
										<div className="button button_file">Select File</div>
									</label>
									<div className="error">{fileError}</div>
									<div className="error">{message}</div>

									<div className="subtitle">(size 300 x 300)</div>

									{image ?
										<div className="icon remove" onClick={remove}><Remove /></div>
										:
										null
									}

								</div>
							</div>

							<div className="flex">
								<div className="download-airdrop">
									{image ?
										<img src={image} alt="" />
										:
										null
									}
								</div>
							</div>
						</div>

						<div>
							<label className="label">Description</label>
							<input type="text" {...register("description", {})} />
							<div className="subheader">
								<h3>Select project users</h3>
							</div>

							<input 
								type="text" 
								placeholder="Search by name or phone number" 
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
								className="search-input"
							/>

							<div className="users">
								{filteredUsers.map(user =>
									<div className="user" key={user.id}>
										<div>
											<CheckboxPhone 
												label={`${user.firstName}`} 
												register={register} 
												name={`users[${user.id}]`} 
												phone={user.phone}
											/>
										</div>
									</div>
								)}
							</div>
							<div className="error">{usersError}</div>
						</div>
					</div>

					<button type="submit" className="button">Send airdrop</button>
					<div className="error">{message}</div>
				</form>
			</div>
		</div>
	)
}